﻿"use strict";

/* @preserve
// ------------------------------------------
// Sign Up JS
// ------------------------------------------
*/

// CapsLocks.JS - [code.iamkate.com] - CC0 1.0 Universal
const CapsLock=function(){var e=/Mac/.test(navigator.platform),b=!1,d=[];window.addEventListener("keypress",function(a){var c=a.charCode;a=a.shiftKey;var f=b;97<=c&&122>=c?b=a:!(65<=c&&90>=c)||a&&e||(b=!a);b!==f&&d.forEach(function(a){return a(b)})});return{isOn:function(){return b},addListener:function(a){d.push(a)}}}();

// Global Variables
window.siteSide = "frontend";
if (document.body.classList.contains("local")) {
    window.localSide = true;
    window.developmentSide = true;
} else {
	window.localSide = false;
	window.developmentSide = false;
}

(async() => {
	// Cached Variables
    const form = document.getElementById("FormSignUp");
    const AccountDomain = document.getElementById("AccountDomain");
	const frequencyButtons = form.querySelectorAll(".btn-frequency");
	const frequency = document.getElementById("Frequency");
	const plan = document.getElementById("Plan");
	const cardNumber = document.getElementById("CardNumber");
	const cardExpirationMonth = document.getElementById("CardExpirationMonth");
    const cardExpirationYear = document.getElementById("CardExpirationYear");
    const cardCVC = document.getElementById("CardCVC");
	const cardFormGroup = form.querySelector(".cc-form-group");
	const cardType = document.getElementById("CardType");
	const cardImage = document.getElementById("CardImage");
	const addressErrors = document.getElementById("AddressErrors");
    const paymentMethod = document.getElementById("PaymentMethod");
    const formPage = document.getElementById("FormPage").value.trim().toUpperCase();
    const password = document.getElementById("Password");
    const emailAddress = document.getElementById("EmailAddress");
    const totalAmount = document.getElementById("Total");

    // Get the version number.
    // ------------------------------------------
    const versionNumber = document.body.getAttribute("data-version");
    window.version = versionNumber;

    // Plugin paths.
    // ------------------------------------------
    let plugins;
    if (window.localSide === true) {
        plugins = {
            "FLPPR-Utilities": "/SharedResources/js/src/FLPPR/js/FLPPR-utilities.js",
            "FLPPR-Modal": "/SharedResources/js/src/FLPPR/js/FLPPR-modal.js",
            "FLPPR-LoadingSpinner": "/SharedResources/js/src/FLPPR/js/FLPPR-loadingspinner.js",
            "FLPPR-Alert": "/SharedResources/js/src/FLPPR/js/FLPPR-alert.js"
        }
    } else {
        plugins = {
            "FLPPR-Utilities": `/SharedResources/js/dist/FLPPR/js/FLPPR-utilities.min.js?version=${window.version}`,
            "FLPPR-Modal": `/SharedResources/js/dist/FLPPR/js/FLPPR-modal.min.js?version=${window.version}`,
            "FLPPR-LoadingSpinner": `/SharedResources/js/dist/FLPPR/js/FLPPR-loadingspinner.min.js?version=${window.version}`,
            "FLPPR-Alert": `/SharedResources/js/dist/FLPPR/js/FLPPR-alert.min.js?version=${versionNumber}`
        }
    }

    // Google Analytics
    // This is not loaded locally.
    // ------------------------------------------
    if (window.localSide === false) {
        try {
            await FLPPR_loader("https://www.googletagmanager.com/gtag/js?id=G-LVVLE17TCD",null,false,"js");
            window.dataLayer = window.dataLayer || [];
            function gtag(){dataLayer.push(arguments);}
            gtag('js', new Date());
            gtag('config', 'G-LVVLE17TCD');
        } catch (error) {
            console.warn("Google Analytics has been blocked:", error);
        }
    }
    
	// Ladda
	// ------------------------------------------
    Ladda.bind('button.btn.ladda-button');
    window.addEventListener("pagehide", event => { if (typeof Ladda === "object") { Ladda.stopAll(); } });

    // Utilities
    // ------------------------------------------
    await FLPPR_loader(plugins["FLPPR-Utilities"])

    // Loading Spinner
    // ------------------------------------------
    await FLPPR_loader(plugins["FLPPR-LoadingSpinner"]);
    FLPPR_loadingspinner.init({ 
        debug: false
    });

    // Modals
    // ------------------------------------------
    await FLPPR_loader(plugins["FLPPR-Modal"]);
    FLPPR_modal.init({
        debug: false,
        bootstrapVersion: 4,
        //alignment: "top",
        pathPrefix: ""
    });

    // Alert
    await FLPPR_loader(plugins["FLPPR-Alert"]);
    FLPPR_alert.init({
        debug: window.localSide
    });

	// AJAX Submit
    // ------------------------------------------
    if (formPage === "CHECKOUT") {
        
        await FLPPR_loader(`/node_modules/jquery-creditcardvalidator/jquery.creditCardValidator.js?version=${window.version}`);
        $('#FirstName').focus();
        $(form).validate({            
            ignore: ".ignore",
            event: "submit",
            onkeyup: false,
            onfocusout: false,
            groups: {
                CCExpiration: "CardExpirationMonth CardExpirationYear",
                Address: "StreetAddress1 StreetAddress2"
            },
            rules: {
                /* Frequency */
                Frequency: { 
                    required: true
                },
                Plan: { 
                    required: true
                },
                /* Basic Information */
                FirstName: { 
                    required: true,
                    maxlength: 50
                },
                LastName: { 
                    required: true,
                    maxlength: 50
                },
                StreetAddress1: { 
                    required: true,
                    maxlength: 150
                },
                StreetAddress2: { 
                    maxlength: 150
                },
                City: { 
                    required: true,
                    maxlength: 150
                },
                StateProv: { 
                    select2Required: true, 
                    required: true,
                    maxlength: 50
                },
                PostalCode: { 
                    required: true,
                    maxlength: 50
                },
                IATA: { 
                    required: true,
                    maxlength: 15
                },
                /* Account */
                EmailAddress: { 
                    required: true, 
                    email: true,
                    //pattern: '.+@' + AccountDomain.value,
                    remote: {
                        type: "post",
                        dataType: 'json',
                        url: "/includes/account/utility/utlFindValueAccounts.asp?lktype=SignUpValidEmailAddress",
                        data: {
                            "T": document.getElementById("T").value,                                                        
                            "S": document.getElementById("S").value
                        },
                        complete: data => {
                            if (data !== undefined && data.responseJSON !== undefined) {
                                if (data.responseJSON.trim().toUpperCase() === "EXPIRED") {
                                    FLPPR_modal.load({
                                        title: "Session Expired",
                                        source: () => "The session has expired.<br/>Please refresh the page and try again.",
                                        closeable: false,
                                        extraClass: "expired"
                                    });
                                }
                            }
                        }
                    }
                },
                Password: {
                    required: true, 
                    minlength: 8, 
                    maxlength: 64
                },
			    PasswordConfirm: { 
                    required: true,
                    equalTo: "#Password"
                },
                /* Credit Card */
                CardNumber: { 
                    required: {
                        param: true,
                        depends: e => parseFloat(totalAmount.value) > 0
                    },
                    creditCardImage: {
                        depends: e => parseFloat(totalAmount.value) > 0,
                        param: {
                            cardTypeInput: cardType,
                            cardFormGroup: cardFormGroup,
                            cardImage: cardImage
                        } 
                    }
                },
                CardExpirationMonth: { 
                    required: {
                        param: true,
                        depends: e => parseFloat(totalAmount.value) > 0
                    },
                    creditCardExpired: {
                        param: "#CardExpirationYear",
                        depends: e => parseFloat(totalAmount.value) > 0
                    }
                },
                CardCVC: { 
                    required: {
                        param: true,
                        depends: e => parseFloat(totalAmount.value) > 0
                    },
                    number: {
                        param: true,
                        depends: e => parseFloat(totalAmount.value) > 0
                    }
                }
            },
            messages: {
                /* Frequency */
                Frequency: { required: 'Please select a frequency.' },
                Plan: { required: 'Please select a plan.'},
                /* Basic Information */
                FirstName: { 
                    required: "Please enter a first name.",
                    maxlength: "First name must be {0} characters or fewer."
                },
                LastName: { 
                    required: "Please enter a last name.",
                    maxlength: "Last name must be {0} characters or fewer."
                },
                StreetAddress1: { 
                    required: "Please enter an address.",
                    maxlength: "Address must be {0} characters or fewer."
                },
                StreetAddress2: { 
                    maxlength: "Secondary address must be {0} characters or fewer."
                },
                City: { 
                    required: "Please enter a city.",
                    maxlength: "City must be {0} characters or fewer."
                },
                StateProv: { 
                    select2Required: "Please enter a state.",
                    required: "Please enter a state.",
                    maxlength: "State must be {0} characters or fewer."
                },
                PostalCode: { 
                    required: "Please enter a zip code.",
                    maxlength: "Zip code must be {0} characters or fewer."
                },
                IATA: { 
                    required: "Please enter your Agency ID.",
                    maxlength: "Agency ID must be {0} characters or fewer."
                }, 
                /* Account */
                EmailAddress: { 
                    required: "Please enter an email address.",
                    email: "Please enter a valid email address." 
                },
                Password: {
                    required: 'Please enter a password.',
                    minlength: 'Password must be at least 8 characters long.',
                    maxlength: 'Password must be less than 64 characters long.'
                },
			    PasswordConfirm: {
                    required: 'Please confirm your password.',
                    equalTo: 'Passwords must match.'
                },
                /* Credit Card */
                CardNumber: { 
                    required: "Please enter a card number.", 
                    creditCardImage: "Card number is not valid." 
                },
                CardExpirationMonth: { 
                    required: "Please enter the expiration month."
                },
                CardCVC: { 
                    required: "Please enter the security code."
                }
            },
            errorPlacement: (error, element) => {
                if ($(element).attr("name") === "StreetAddress1" || $(element).attr("name") === "StreetAddress2") {
                    $(addressErrors).append(error);
                } else {
                    if ($(element).closest(".form-group")) {
                        $(element).closest(".form-group").append(error);
                    } else {
                        error.insertAfter(element);
                    }
                }
            },
            invalidHandler: (f, validator) => { 
                if (validator.numberOfInvalids()) {
                    // Show the validation error(s) in the console
                    $('#basicinfoDiv').removeClass('d-none');
                    if (console.groupCollapsed !== undefined) {
                        console.groupCollapsed("[Validation] # Errors: [", Object.keys(validator.errorList).length, "]");
                    } else {
                        console.info("[Validation] # Errors: [", Object.keys(validator.errorList).length, "]");
                    }
                    let errorCount = 1;
                    Array.from(validator.errorList).forEach(error => {
                        const errorObj = $(error.element);
                        console.warn(`#${errorCount} - "${errorObj.attr("name")}" - ${error.message}`,errorObj);
                        if (errorCount === 1) {
                            const scrollEl = error.element.closest(".form-group") !== null ? error.element.closest(".form-group") : error.element;
                            window.scroll({
                                top: scrollEl.getBoundingClientRect().top + window.scrollY - 10,
                                left:0,
                                behavior: 'smooth'
                            });
                        }
                        ++errorCount;
                    });
                    if (console.groupCollapsed !== undefined) { console.groupEnd(); }
                    if (Ladda !== undefined) { Ladda.stopAll(); }
                }
            }
        });
    }

    

    // Update the price
    // ------------------------------------------
    const UpdatePrice = () => {
        let planPrice = 0;
        const selectedPlan = form.querySelector(".plan-card.active");
        if (selectedPlan !== null) {
            planPrice = selectedPlan.querySelector(".price").innerText;
            planPrice = parseFloat(planPrice.replace("$",""));
        }
        if (planPrice > 0) {
            paymentMethod.style.display = "block";
            totalAmount.value = planPrice;
        } else {
            paymentMethod.style.display = "none";
            totalAmount.value = 0;
        }
        $('#basicinfoDiv').removeClass('d-none');
        $('#continue1').removeClass('d-none');
        $('#accountDiv').addClass('d-none')
        $('#continue2').addClass('d-none')
        $('#continuesubmit').addClass('d-none')
        $('#FirstName').focus();

    };
    $(form).on("click", "#btn-back1", e => {
        //$("#FormSignUp").validate({ ignore: ":not(:visible)" });
        $('#accountDiv').addClass('d-none')
        $('#basicinfoDiv').removeClass('d-none')
        $('#continue1').removeClass('d-none')
        $('#continuesubmit').addClass('d-none')
        $('#StreetAddress1').focus();

    });

    $(form).on("click", "#btn-continue1", e => {
        //$("#FormSignUp").validate({ ignore: ":not(:visible)" });
        $('#accountDiv').removeClass('d-none')
        $('#basicinfoDiv').addClass('d-none')
        $('#continue1').addClass('d-none')
        $('#continuesubmit').removeClass('d-none')
        $('#StreetAddress1').focus();
        
    });

    // Open the "promo" .
    // ------------------------------------------
    $(form).on("click", "#btn-Apply-Promo", async e => {
        const promoCode = document.getElementById("promoCode").value;
        const EmailAddress = document.getElementById("EmailAddress").value;
        if (promoCode > '') {
            const response = await fetch("/includes/account/utility/utlFindValueAccounts.asp?lktype=applyPromoCode", {
                method: "POST",
                credentials: "same-origin",
                cache: "no-cache",
                headers: {
                    "Content-Type": "application/x-www-form-urlencoded"
                },
                body: new URLSearchParams({
                    "plan": promoCode,
                    "EmailAddress": EmailAddress,
                    "frequency": document.getElementById("Frequency").value
                })
            });
            if (response.ok) {
                const responseHTML = await response.text();
                const selectPlanDiv = document.getElementById("selectPlanDiv");
                selectPlanDiv.innerHTML = responseHTML;
                $('.Reset-Promo').removeClass('d-none');
            } else {
                if (EmailAddress > '')
                {
                    alert("Invalid Promo Code or invalid promo code for email address entered.");
                }
                else
                {
                    alert("Invalid Promo Code.");
                }
                
                //FLPPR_alert.show({
                //    message: "Invalid Promo Code.",
                //    color: "danger"
                //});
            }
        }
        e.preventDefault();

    });
    // Open the "promo" .
    // ------------------------------------------
    $(form).on("click", "#btn-Reset-Promo", async e => {
        const promoCode = ""; document.getElementById("promoCode").value;
        document.getElementById("promoCode").value = "";
            const response = await fetch("/includes/account/utility/utlFindValueAccounts.asp?lktype=applyPromoCode", {
                method: "POST",
                credentials: "same-origin",
                cache: "no-cache",
                headers: {
                    "Content-Type": "application/x-www-form-urlencoded"
                },
                body: new URLSearchParams({
                    "plan": promoCode
                })
            });
        if (response.ok) {
            const responseHTML = await response.text();
            const selectPlanDiv = document.getElementById("selectPlanDiv");
            selectPlanDiv.innerHTML = responseHTML;
            $('.Reset-Promo').addClass('d-none');
        } else {

        }
        
        e.preventDefault();
    });


    // Open the "promo" .
    // ------------------------------------------
    // [How Did You Hear About Us] - Show/hide "Other" text input
    // ------------------------------------------
    const howHearOtherDiv = document.getElementById('HowDidYouHearAboutUsOtherDiv');
    const howHearOtherInput = document.getElementById('HowDidYouHearAboutUsOther');
    if (howHearOtherDiv && howHearOtherInput) {
        const toggleHowHearOther = () => {
            const isOther = document.getElementById('HowDidYouHearAboutUs').value === 'Other';
            howHearOtherDiv.style.display = isOther ? '' : 'none';
            if (isOther) {
                howHearOtherInput.setAttribute('required', 'required');
            } else {
                howHearOtherInput.removeAttribute('required');
                howHearOtherInput.value = '';
            }
        };
        $(form).on('change', '#HowDidYouHearAboutUs', toggleHowHearOther);
        // Run on init in case of back-navigation with a value already selected
        toggleHowHearOther();
    }

    $(form).on("change", "#EmailAddress", async e => {

        const validEmail = checkDomain();
        if (validEmail == false) {
            alert("Invalid email address for promo code used. Please enter a valid email address or try a different promo code.");
            /*FLPPR_alert.show({
                message: "Invalid email address for promo code used.",
                debug: true,
                color: "danger"
            });*/
            document.getElementById("EmailAddress").value = "";
        }
        e.preventDefault();
    });

    function checkDomain() {
        // Check the substring starting at the @ against the domain
        const AccountDomain = "@" + document.getElementById("AccountDomain").value;
        const EmailAddress = document.getElementById("EmailAddress").value;
        if (AccountDomain > '@') {
            return (EmailAddress.substring(EmailAddress.indexOf('@')) == AccountDomain)
        }
        else
        {
            return true;
        }
    }

    $(form).on("click", "#btn-continuesubmit", e => {
        $('#basicinfoDiv').removeClass('d-none')                

    });

	// Choose a frequency
	// ------------------------------------------
	$(form).on("click",".btn-frequency", e => {
		const thisBtn = e.currentTarget;
		if (!thisBtn.classList.contains("active")) {
			const plansClasses = document.getElementById("Plans").classList;
            const thisFrequency = thisBtn.getAttribute("data-frequency");
            const frequency = document.getElementById("Frequency");
			let priceAttribute;
			switch (thisFrequency.trim().toUpperCase()) {
				case "MONTHLY":
					priceAttribute = "data-monthlyprice";
					frequency.value = "monthly";
					plansClasses.remove("yearly", "quarterly");
                    plansClasses.add("monthly");
                   // $('#freqmonth').removeClass('active')
                    $('#freqquarter').removeClass('active')
                    $('#freqannual').removeClass('active')
					break;
				case "YEARLY":
					priceAttribute = "data-yearlyprice";
					frequency.value = "yearly";
					plansClasses.remove("monthly", "quarterly");
					plansClasses.add("yearly");
                    $('#freqmonth').removeClass('active')
                    $('#freqquarter').removeClass('active')
                    //$('#freqannual').removeClass('active')
                    break;
				case "QUARTERLY":
					priceAttribute = "data-quarterlyprice";
					frequency.value = "quarterly";
					plansClasses.remove("monthly", "yearly");
                    plansClasses.add("quarterly");
                     $('#freqmonth').removeClass('active')
                    //$('#freqquarter').removeClass('active')
                    $('#freqannual').removeClass('active')

					break;
			}
			// Change all of the plan buttons' prices.
			Array.from(form.querySelectorAll(".plan-card")).forEach(plan => {
                const planBtn = plan.querySelector(".btn");
                if (planBtn !== null) {
                    const thisPrice = planBtn.getAttribute(priceAttribute);
                    const priceArea = plan.querySelector(".price");
                    if (!priceArea.classList.contains("no-change")) {
                        priceArea.innerText = `$${thisPrice}`;
                    }
                }
			});
			// Change the plan button's frequency text.
			Array.from(form.querySelectorAll(".frequency-text")).forEach(child => {
				child.innerText = thisFrequency.trim().toLowerCase();
			});
			thisBtn.classList.add("active");
			Array.from(frequencyButtons).forEach(child => {
				if (child !== thisBtn) {
					child.classList.remove("active");
				}
			});
            UpdatePrice();
		}
	});

	// Choose a plan
	// ------------------------------------------
	$(form).on("click",".plan-card .btn", e => {
		const targetBtn = e.currentTarget;
		const tier = targetBtn.getAttribute("data-tier");
        const parentCard = targetBtn.closest(".plan-card");
        plan.value = tier;
        document.getElementById("Plan").value = tier;
        parentCard.classList.add("active");
        targetBtn.innerText = "Selected";
        targetBtn.disabled = true;
        targetBtn.classList.add("disabled");
        targetBtn.classList.remove("ripple");
        targetBtn.blur();
		Array.from(form.querySelectorAll(".plan-card")).forEach(card => {
			if (card !== parentCard) {
                const cardBtn = card.querySelector(".btn");
                card.classList.remove("active");
                if (cardBtn !== null) {
                    cardBtn.disabled = false;
                    cardBtn.innerText = "Select";
                    cardBtn.classList.remove("disabled");
                    cardBtn.classList.add("ripple");
                }
            }
		});
        UpdatePrice();
      //  $(plan).valid();
	});

    // Return back to the first page (checkout)
	// ------------------------------------------
	$(form).on("click",".btn-back", e => {
		form.setAttribute("action","/sign-up");
        form.submit();
	});

	// Phone Masking (Cleave.JS)
	// ------------------------------------------
	const phoneMaskFields = form.querySelectorAll(".phone-mask");
    if (phoneMaskFields.length > 0) {
        Array.from(phoneMaskFields).forEach(child => {
            new Cleave(child, {
                numericOnly: true,
                blocks: [0, 3, 0, 3, 4],
                delimiters: ["(", ")", " ", "-"]
            });
        });
    }

    if (formPage === "CHECKOUT") {
        // Credit Card Mask (Cleave.JS)
        // ------------------------------------------
        new Cleave(cardNumber, {
            creditCard: true,
            onValueChanged: e => {
                $(cardNumber).valid();
            }
        });

         // Credit Card - CVC (Cleave.JS)
        // ------------------------------------------
        new Cleave(cardCVC, {
            numericOnly: true,
            blocks: [4]
        });

        // Credit Card - Expiration Month (Cleave.JS)
        // ------------------------------------------
        new Cleave(cardExpirationMonth, {
            date: true,
            datePattern: ['m']
        });

        // Credit Card - Expiration Year (Cleave.JS)
        // ------------------------------------------
        new Cleave(cardExpirationYear, {
            date: true,
            datePattern: ['y']
        });

        // Validate the month/year on change.
        // ------------------------------------------
        const MonthYearDebounce = FLPPR_utilities.Debounce(() => {
            $(cardExpirationMonth).valid();
            $(cardExpirationYear).valid();
        }, 250);
        $(form).on('blur change keyup', "#CardExpirationMonth,#CardExpirationYear", MonthYearDebounce); 

        // Move to the year field when the month is filled out.
        // ------------------------------------------
        $(form).on("keyup","#CardExpirationMonth", e => {
            if (e.key !== "Tab") {
                if (e.currentTarget.value.length >= 2) {
                    cardExpirationYear.focus();
                } 
            }
        });
    }

	// Select2 (Only fired on desktop)
    // ------------------------------------------
    if (formPage === "CHECKOUT") {
        if (Math.round(window.innerWidth) > 992) {
            await FLPPR_loader(`/node_modules/select2/dist/js/select2.full.min.js?version=${window.version}`);
            $.fn.select2.defaults.set("theme", "bootstrap4");
            $("#StateProv").removeClass("form-control").select2({
                width: '100%',
                dropdownAutoWidth: true,
                allowClear: true,
                matcher: (params, data) =>  {
                    let returnVal = null;
                    if (params.term && params.term.length > 0) {
                        const searchTerm = params.term.trim();
                        let opt;
                        if (data.children !== undefined) {
                            let filteredChildren = data.children.filter(child => {
                                opt = child.element;
                                if (searchTerm.length === 2) {
                                    if (opt.hasAttribute("data-searchtags") && opt.getAttribute("data-searchtags").trim().length === 2 && opt.getAttribute("data-searchtags").trim().toUpperCase() === searchTerm.toUpperCase()) {
                                        return child;
                                    } else if (opt.hasAttribute("value") && opt.getAttribute("value").trim().toUpperCase() === searchTerm.toUpperCase()) {
                                        return child;
                                    }
                                } else if (child.text.toUpperCase().indexOf(searchTerm.toUpperCase()) >= 0 || opt.hasAttribute("data-searchtags") && opt.getAttribute("data-searchtags").toUpperCase().indexOf(searchTerm.toUpperCase()) >= 0) {
                                    return child;
                                }
                            });
                            if (filteredChildren.length) {
                                let modifiedData = FLPPR_utilities.DeepExtend({}, data, true);
                                modifiedData.children = filteredChildren;
                                returnVal = modifiedData;
                            }
                        } else {
                            opt = data.element;
                            if (searchTerm.length === 2) {
                                if (opt.hasAttribute("data-searchtags") && opt.getAttribute("data-searchtags").trim().length === 2 && opt.getAttribute("data-searchtags").trim().toUpperCase() === searchTerm.toUpperCase()) {
                                    returnVal = data;
                                } else if (opt.hasAttribute("value") && opt.getAttribute("value").trim().toUpperCase() === searchTerm.toUpperCase()) {
                                    returnVal = data;
                                }
                            } else if (data.text.toUpperCase().indexOf(searchTerm.toUpperCase()) >= 0 || opt.hasAttribute("data-searchtags") && opt.getAttribute("data-searchtags").toUpperCase().indexOf(searchTerm.toUpperCase()) >= 0) {
                                returnVal = data;
                            }
                        }
                    } else {
                        returnVal = data;
                    }
                    return returnVal;
                },
                templateResult: item => {
                    let returnHTML = "";
                    const thisText = item["text"];
                    if (item["selected"] !== undefined && item["selected"] === true) {
                        returnHTML = `<div class="filter-dropdown-option selected">${thisText}</div>`;
                    } else {
                        returnHTML = `<div class="filter-dropdown-option">${thisText}</div>`;
                    }
                    return document.createRange().createContextualFragment(returnHTML);
                },
                placeholder: {id: "-1"}
            }).change(e => {
                $(e.target).valid();
            });
            /* @preserve
            Monkeypatches to get Select2 to work upon focus (tabbing, etc.)
            // Fix by turekl/achimha (https://github.com/select2/select2/issues/3279#issuecomment-442524147) */
            $(document).on("select2:open", e => {
                $(e.target).data("select2").dropdown.$search[0].focus();
            });
            document.addEventListener("click", ev => {
                if (!ev.target.classList.contains("select2-label")) return;
                let target = $(document.getElementById(ev.target.getAttribute("for")));
                if (!target.length) return;
                target.select2("open");
                $(target).data("select2").dropdown.$search[0].focus();
            });
            document.addEventListener("select2:unselecting", function() {
                $(this).one("select2:opening.cancelOpen", e => {
                    e.preventDefault();
                });
            });
        }
    }

	const GetBodyWidthSize = () => {
        // Adds the class "width-*" to the body corresponding to the bootstrap sizes.
        // Fired on initial page load and resize.
        const windowWidth = Math.round(window.innerWidth);
        let bootstrapWidth = "";
        if (windowWidth < 576) {
            // Extra Small (XS) (MOBILE)
            document.body.classList.remove("width-sm","width-md","width-lg","width-xl","width-xxl","width-xxxl");
            document.body.classList.add("width-xs","mobile");
            bootstrapWidth = "XS";
        } else if (windowWidth >= 576 && windowWidth < 768) {
            // Small (SM) (MOBILE)
            document.body.classList.remove("width-xs","width-md","width-lg","width-xl","width-xxl","width-xxxl");
            document.body.classList.add("width-sm","mobile");
            bootstrapWidth = "SM";
        } else if (windowWidth >= 768 && windowWidth < 992) {
            // Medium (MD) (MOBILE)
            document.body.classList.remove("width-xs","width-sm","width-lg","width-xl","width-xxl","width-xxxl");
            document.body.classList.add("width-md","mobile");
            bootstrapWidth = "MD";
        } else if (windowWidth >= 992 && windowWidth < 1200) {
            // Large (LG)
            document.body.classList.remove("width-xs","width-sm","width-md","width-xl","width-xxl","width-xxxl","mobile");
            document.body.classList.add("width-lg");
            bootstrapWidth = "LG";
        } else if (windowWidth >= 1200 && windowWidth < 1440) {
            // Extra Large (XL)
            document.body.classList.remove("width-xs","width-sm","width-md","width-lg","width-xxl","width-xxxl","mobile");
            document.body.classList.add("width-xl");
            bootstrapWidth = "XL";
        } else if (windowWidth >= 1440  && windowWidth < 1600) {
            // Extra-Extra Large (XXL)
            document.body.classList.remove("width-xs","width-sm","width-md","width-lg","width-xl","width-xxxl","mobile");
            document.body.classList.add("width-xxl");
            bootstrapWidth = "XXL";
        } else if (windowWidth >= 1600) {
            // Extra-Extra-Extra Large (XXXL)
            document.body.classList.remove("width-xs","width-sm","width-md","width-lg","width-xl","width-xxl","mobile");
            document.body.classList.add("width-xxxl");
            bootstrapWidth = "XXXL";
        }
        //console.info("Window width: [", windowWidth, "]px = [", bootstrapWidth, "]");
    };

    // Get the current window width in bootstrap grid notation
    // ------------------------------------------
    GetBodyWidthSize();

    // Window Resize Events
    // ------------------------------------------
    const ResizeFunctions = () => {
        GetBodyWidthSize();
    };
    const DebouncedResize = FLPPR_utilities.Debounce(ResizeFunctions, 500);
    $(window).on("resize", DebouncedResize);

    // Show a warning if caps lock is on for the password.
    // ------------------------------------------
    if (formPage === "CHECKOUT") {
        let capslockPopoverShown = false;
        const passwordPopover = $(password).closest(".input-group");
        passwordPopover.popover({
            content: `<i class="fa fa-exclamation-triangle mr-2" aria-hidden="true"></i>Caps Lock is on`,
            trigger: "manual",
            placement: "right",
            fallbackPlacement: ["right","top"],
            sanitize: false,
            html: true,
            template: `<div class="popover popover-danger" role="tooltip"><div class="arrow"></div><h3 class="popover-header"></h3><div class="popover-body"></div></div>`
        });
        CapsLock.addListener(isOn => {
            if (isOn && capslockPopoverShown === false) {
                passwordPopover.popover("show");
                capslockPopoverShown = true;
            } else if (!isOn && capslockPopoverShown === true) {
                passwordPopover.popover("hide");
                capslockPopoverShown = false;
            }
        });
    }

    // Validate the Email Address on change/blur.
    // ------------------------------------------
    if (formPage === "CHECKOUT") {
        const ChangeDebounceEmail = FLPPR_utilities.Debounce(() => {
            $(emailAddress).removeData("previousValue");
            $(emailAddress).valid();
        },300);
        $(form).on("blur",'#EmailAddress',ChangeDebounceEmail);
    }

    // Check the current session.
    // Each session lasts for 45 minutes.
    // If session has ended, display a modal.
    // Checks every [5min].
    // ------------------------------------------
    let sessionCheckTimer;
    const CheckSession = async () => {
        const response = await fetch("/includes/account/utility/utlFindValueAccounts.asp?lkType=SignUpCheckSession", {
            method: "POST",
            credentials: "same-origin",
            cache: "no-cache",
            headers: {
                "Content-Type": "application/x-www-form-urlencoded"
            },
            body: new URLSearchParams({
                "T": document.getElementById("T").value,
                "S": document.getElementById("S").value
            })
        });
        if (response.ok) {
            const sessionStatus = await response.text();
            switch(sessionStatus.trim().toUpperCase()) {
                case "TRUE":
                    clearTimeout(sessionCheckTimer);
                    sessionCheckTimer = setTimeout(CheckSession, 300000);
                    break;
                default:
                    // Session has ended.
                    clearTimeout(sessionCheckTimer);
                    FLPPR_modal.load({
                        title: "Session Expired",
                        source: () => "The session has expired.<br/>Please refresh the page and try again.",
                        closeable: false,
                        extraClass: "expired"
                    });
            }
        }
    };
    sessionCheckTimer = setTimeout(CheckSession, 300000);

    // Open the "Privacy Policy" modal.
	// ------------------------------------------
	$(document).on("click",".btn-privacypolicy",e => {
		FLPPR_modal.load({
			title: "Privacy Policy",
			source: "login/modals/modal-privacypolicy",
            script: false
		});
		e.preventDefault();
	});

	// Open the "Terms of Use" modal.
	// ------------------------------------------
	$(document).on("click",".btn-termsofuse",e => {
		FLPPR_modal.load({
			title: "Terms of Use",
			source: "login/modals/modal-termsofuse",
            script: false
		});
		e.preventDefault();
	});

    // Open the "About" modal.
	// ------------------------------------------
	$(document).on("click",".btn-about",e => {
		FLPPR_modal.load({
			title: "About",
			source: "about/about"
		});
		e.preventDefault();
    });

    

})();